import React, { useEffect } from 'react';
import '../App.css';

function Gallery() {
  const galleryImages = [
    '/images/01.jpeg',
    '/images/02.jpeg',
    '/images/03.jpeg',
    '/images/04.jpeg',
    '/images/05.jpeg',
    '/events/best-nasha-mukti-kendra-in-patna-nihansh-foundation-01.jpeg',
    '/events/best-nasha-mukti-kendra-in-patna-nihansh-foundation-03.jpeg',
    '/events/best-nasha-mukti-kendra-in-patna-nihansh-foundation-04.jpeg',
    '/events/best-nasha-mukti-kendra-in-patna-nihansh-foundation-05.jpeg',
    '/events/best-nasha-mukti-kendra-in-patna-nihansh-foundation-06.jpeg',
    '/events/best-nasha-mukti-kendra-in-patna-nihansh-foundation-07.jpeg',
    '/events/best-nasha-mukti-kendra-in-patna-nihansh-foundation-08.jpeg',
    '/events/best-nasha-mukti-kendra-in-patna-nihansh-foundation-09.jpeg',
    '/events/best-nasha-mukti-kendra-in-patna-nihansh-foundation-10.jpeg',
    '/events/best=-nasha-mukti-kendra-nihansh-foundation-01.jpeg',
    '/events/best=-nasha-mukti-kendra-nihansh-foundation-02.jpeg',
    '/events/counselling.jpeg',
    '/events/counselling_01.jpeg',
    '/events/sankrant.jpeg',
    '/events/sankranti.jpeg',
    
  ];

  const [selectedImage, setSelectedImage] = React.useState(null);
  const [fullscreenGallery, setFullscreenGallery] = React.useState(false);

  const openImageModal = (imageSrc) => {
    setSelectedImage(imageSrc);
    document.body.style.overflow = 'hidden';
  };

  const closeImageModal = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  const openFullscreenGallery = () => {
    setFullscreenGallery(true);
    document.body.style.overflow = 'hidden';
  };

  const closeFullscreenGallery = () => {
    setFullscreenGallery(false);
    document.body.style.overflow = 'auto';
  };

  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll('.animate-on-scroll');
      elements.forEach(element => {
        const elementTop = element.getBoundingClientRect().top;
        const elementVisible = 150;
        
        if (elementTop < window.innerHeight - elementVisible) {
          element.classList.add('animate');
        }
      });
    };

    setTimeout(() => {
      handleScroll();
    }, 100);
    
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  React.useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        closeImageModal();
      }
    };

    if (selectedImage) {
      window.addEventListener('keydown', handleEscape);
      return () => window.removeEventListener('keydown', handleEscape);
    }
  }, [selectedImage]);

  return (
    <div className="App">
      {/* Page Hero */}
      <section 
        className="page-hero gallery-hero"
        style={{
          backgroundImage: 'url(/images/Cigarette addiction.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          position: 'relative'
        }}
      >
        <div className="page-hero-background">
          <div className="page-hero-overlay"></div>
        </div>
        <div className="page-hero-content">
          <h1 className="page-hero-title">Gallery</h1>
          <p className="page-hero-subtitle">निहांश फाउंडेशन की तस्वीरें</p>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="gallery-section">
        <div className="container">
          <h2 className="section-title animate-on-scroll" style={{ color: '#1e1e1e' }}>Our Gallery</h2>
          <p className="section-subtitle animate-on-scroll" style={{ color: '#64748b' }}>निहांश फाउंडेशन की विभिन्न गतिविधियों और कार्यक्रमों की तस्वीरें</p>
          <div className="gallery-grid">
            {galleryImages.map((image, index) => (
              <div 
                key={index} 
                className="gallery-item animate-on-scroll" 
                style={{ animationDelay: `${index * 0.05}s` }}
                onClick={() => openImageModal(image)}
              >
                <img 
                  src={image} 
                  alt={`Gallery ${index + 1}`} 
                  className="gallery-image"
                  loading="lazy"
                  style={{ display: 'block', width: '100%', height: '100%' }}
                  onError={(e) => {
                    console.error('Image failed to load:', image);
                    e.target.style.display = 'none';
                  }}
                  onLoad={(e) => {
                    e.target.style.opacity = '1';
                    e.target.style.display = 'block';
                  }}
                />
                <div className="gallery-overlay">
                  <span className="gallery-icon">🔍</span>
                </div>
              </div>
            ))}
          </div>
          
          {/* See More Button */}
          <div className="gallery-see-more-container">
            <button className="gallery-see-more-btn" onClick={openFullscreenGallery}>
              <span className="btn-icon">�</span>
              See More
            </button>
          </div>
        </div>
      </section>

      {/* Image Modal/Popup */}
      {selectedImage && (
        <div className="image-modal" onClick={closeImageModal}>
          <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="image-modal-close" onClick={closeImageModal}>×</button>
            <img src={selectedImage} alt="Gallery" className="image-modal-image" />
          </div>
        </div>
      )}

      {/* Fullscreen Gallery View */}
      {fullscreenGallery && (
        <div className="fullscreen-gallery">
          <button className="fullscreen-gallery-close" onClick={closeFullscreenGallery}>×</button>
          <div className="fullscreen-gallery-grid">
            {galleryImages.map((image, index) => (
              <div 
                key={index}
                className="fullscreen-gallery-item"
                onClick={() => {
                  setSelectedImage(image);
                }}
              >
                <img 
                  src={image} 
                  alt={`Gallery ${index + 1}`}
                  className="fullscreen-gallery-image"
                  loading="lazy"
                  onError={(e) => {
                    console.error('Image failed to load:', image);
                    e.target.style.display = 'none';
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default Gallery;

